<template>
  <div>
      <div class="flex">
        <div class="flex-1">
            <div class="text-center">
                <div style="padding: 20px 0;color:#650004;font-size:20px;">{{getInfo ? deptObj.title : deptObj.deptName}}</div>
                <div class="flex just-center align-center" style="height:35px;background: #F5F5F5;">
                    <div>发布时间：{{ getInfo ? deptObj.publishTime.split('T')[0] : deptObj.createTime.split('T')[0]}}</div>
                    <!-- <div>发布人：{{deptObj.createUser}}</div> -->
                </div>
                <div class="content-box ql-editor" v-html="getInfo ? deptObj.content : deptObj.dutyContext"></div>
                <div class="flex" v-if="deptObj.attachments && deptObj.attachments.length > 0" style="color:red;text-align:left;">
                    <div style="padding:5px 0;">附件下载：</div>
                    <ul>
                        <li v-for="(item, index) in deptObj.attachments" :key="index" style="text-align:left;padding:5px;">
                            <a target="_blank" :href=item.url>{{item.name + item.type}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
    props: {
        deptObj: {
            type: Object,
            required: true
        },
        getInfo: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {

        }
    },
    methods: {},
    mounted() {
    },
}
</script>

<style scoped lang='less'>
.mar-right-10 {
    margin-right:10px;
    width: 16px;
    height:16px;
}
.active-class{
    border-left: 2px solid #650004;
    background: #FFEFF0;
}
p {
    margin-bottom:20px;
}
.back-btn{
    width:50px;
    height:30px;
    background:#650004;
    color:#fff;
    font-size:16px;
    text-align: center;
    line-height:30px
}
.content-box{
    // min-height:320px;
    width:1000px;
    margin-top:22px;
    text-align:left;
    line-height: 24px;
}
/deep/ .content-box img{
    width: 100%;
    height: 100%;
}
img {
    width: 100% !important;
}
</style>
